import { Action } from '@reduxjs/toolkit'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { UserModel } from '../models/UserModel'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  Login: '[Login] Action',
  Logout: '[Logout] Action',
  SetSessionId: '[SetSessionId] Action',
  SetStatus: '[SetStatus] Action',
  SetOtpValidate: '[SetOtpValidate] Action'
}

const initialAuthState: IAuthState = {
  user: undefined,
  sessionId: 'closed',
  erp: [],
  partner1: [],
  partner2: [],
  status1: [],
  status2: [],
  accountSystem: "",
  rights: {},
}

export interface IAuthState {
  user?: UserModel,
  sessionId: string,
  accountSystem: string,
  erp: [],
  partner1: [],
  partner2: [],
  status1: [],
  status2: [],
  rights: {},
}

export const reducer = persistReducer(
  { storage, key: 'portal-auth', whitelist: ['user', 'erp', 'instance', 'partner1', 'partner2', 'status1', 'status2', 'rights', 'sessionId'] },
  (state: IAuthState = initialAuthState, action: any) => {
    switch (action.type) {
      case actionTypes.Login: {
        let user: any = JSON.parse(action.payload?.data?.userdata);
        user.salt = user.apipw;
        user.saltid = action.payload?.data?.saltid;
        user.code = action.payload?.data?.code;
        user.sessionId = user.apipw;
        let erp = JSON.parse(action.payload?.data?.erp);
        let partner1 = JSON.parse(action.payload?.data?.partner1);
        let partner2 = action.payload?.data?.partner2;
        const status1 = JSON.parse(action.payload?.data?.status1);
        const status2 = JSON.parse(action.payload?.data?.status2);
        const rights = action.payload?.data?.rights;
        const accountSystem = action.payload?.data?.accountSystem;
        // const sessionId = user.apipw;
        return { ...state, user, accountSystem, erp, partner1, partner2, status1, status2, rights }
      }

      case actionTypes.Logout: {
        return initialAuthState
      }

      case actionTypes.SetStatus: {
        const status2 = JSON.parse(action.payload?.data?.status);
        return { ...state, status2 }
      }

      case actionTypes.SetSessionId: {
        const sessionId = action.payload.data;
        return { ...state, sessionId }
      }

      case actionTypes.SetOtpValidate: {
        const user = { ...state.user, ...action.payload.data };
        return { ...state, user }
      }

      default:
        return state
    }
  }
)

export const actions = {
  login: (data: any) => ({ type: actionTypes.Login, payload: { data } }),
  logout: () => ({ type: actionTypes.Logout }),
  setSessionId: (data: any) => ({ type: actionTypes.SetSessionId, payload: { data } }),
  setStatus: (data: any) => ({ type: actionTypes.SetStatus, payload: { data } }),
  setOtpValidate: (data: any) => ({ type: actionTypes.SetOtpValidate, payload: { data } }),
  store: () => ({ type: "def" }),
}

export function* saga() {

}
